/**
 * Controller for the subscription upgrade modal.
 * Allows users to select between monthly and annual plans.
 */
angular.module('admin')
.controller('UpgradeModalController', ['$scope', '$timeout', '$uibModalInstance', 'Subscription', 'SubscriptionHelper', 'Logger', 'currentStatus', 'feature', 'source', 'PREMIUM_FEATURES', 'FREE_TRIAL_PERIOD',
    function ($scope, $timeout, $uibModalInstance, Subscription, SubscriptionHelper, Logger, currentStatus, feature, source, PREMIUM_FEATURES, FREE_TRIAL_PERIOD) {

        var STATUS_WAIT_MS = 5000;

        // DCL-561: the dialog checks trial eligibility automatically — the
        // backend's trial_available flag flips every piece of copy between the
        // free-trial invitation and the plain upgrade wording.
        function applyStatus(status) {
            $scope.trialAvailable = !!(status && status.trial_available);
        }

        applyStatus(currentStatus);
        // DCL-645: which entry point opened the dialog, for DCL-532 attribution.
        $scope.source = source;
        $scope.trialDays = FREE_TRIAL_PERIOD;
        // Default to monthly. Annual is gated by the backend flag (DCL-379); when it's
        // enabled the default flips back to annual once prices load (below).
        $scope.selectedInterval = 'month';
        $scope.annualBillingEnabled = false;
        $scope.prices = null;
        $scope.loading = true;
        $scope.error = null;
        // DCL-645: a 402 opens the dialog with no status. The offer stays hidden
        // until it is known, so a practice due the trial doesn't see the plain
        // upgrade first, unless the status is too slow (below).
        $scope.statusLoading = !currentStatus;

        // Load available prices
        Subscription.getPrices({}, function(prices) {
            $scope.prices = prices;
            $scope.annualBillingEnabled = !!prices.annual_billing_enabled;
            if ($scope.annualBillingEnabled) {
                $scope.selectedInterval = 'year'; // Annual is the better-value default when offered
            }
            $scope.loading = false;
        }, function(error) {
            $scope.error = 'Unable to load pricing information';
            $scope.loading = false;
        });

        // Format price for display
        $scope.formatPrice = function(cents) {
            return SubscriptionHelper.formatPrice(cents);
        };

        // Calculate monthly equivalent for annual plan
        $scope.getMonthlyEquivalent = function() {
            if (!$scope.prices || !$scope.prices.annual) return '';
            var monthlyEquiv = $scope.prices.annual.amount / 12;
            return SubscriptionHelper.formatPrice(monthlyEquiv);
        };

        // Calculate annual savings
        $scope.getAnnualSavings = function() {
            if (!$scope.prices) return '';
            var annualIfMonthly = $scope.prices.monthly.amount * 12;
            var savings = annualIfMonthly - $scope.prices.annual.amount;
            return SubscriptionHelper.formatPrice(savings);
        };

        // Select plan and close modal
        $scope.selectPlan = function(interval) {
            $scope.selectedInterval = interval;
            $uibModalInstance.close(interval);
        };

        // Cancel modal
        $scope.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        };

        // Premium features list (shared with the Plan & usage page — see the
        // PREMIUM_FEATURES constant in app.js). General dentists already get the
        // specialist-only ones on Basic, so they aren't offered as Premium. A 402
        // opens the modal with no status, so those stay hidden until the practice
        // type is known: better to leave a card off than to sell what Basic includes.
        function showFeatures(status) {
            var offerSpecialistOnly = !!status && status.practice_type !== 'general_dentistry';
            var offered = PREMIUM_FEATURES.filter(function (premiumFeature) {
                return !premiumFeature.specialistOnly || offerSpecialistOnly;
            });
            $scope.features = offered.filter(isBlocked).concat(offered.filter(function (premiumFeature) {
                return !isBlocked(premiumFeature);
            }));
        }

        // DCL-645: lead with what the user just tried to do. Every card has a `key`,
        // but only a gate has a headline; anything else leaves the dialog generic.
        function isBlocked(premiumFeature) {
            return !!premiumFeature.blockedHeadline && premiumFeature.key === feature;
        }

        $scope.blockedFeature = PREMIUM_FEATURES.filter(isBlocked)[0] || null;

        showFeatures(currentStatus);

        if ($scope.statusLoading) {
            // The status can wait on Stripe, so don't hold the upgrade for it. A late
            // answer still corrects the offer.
            var statusWait = $timeout(function () {
                $scope.statusLoading = false;
            }, STATUS_WAIT_MS);

            Subscription.getStatus({}, function (status) {
                $timeout.cancel(statusWait);
                applyStatus(status);
                showFeatures(status);
                $scope.statusLoading = false;
            }, function (error) {
                // Only the wording and the specialist-only cards are lost: checkout
                // still decides the trial on the server, so don't block the upgrade.
                $timeout.cancel(statusWait);
                Logger.log('Upgrade modal could not load the subscription status: ' + JSON.stringify(error));
                $scope.statusLoading = false;
            });
        }

    }]);
